import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Status } from 'src/models/AuthContextModels';
import { initialState } from './types';
import { fetchForecastPlanningCycles, fetchPlanningCycles, fetchScenarios, fetchSnapshots, submitPlanningCycle } from './planningCycleThunks';

/**
 * Redux slice for planning cycle management
 */
const planningCycleSlice = createSlice({
  name: 'planningCycle',
  initialState,
  reducers: {
    // Place for reducers handling synchronous actions
  },
  extraReducers: (builder) => {
    builder
      // Fetch Planning Cycles
      .addCase(fetchPlanningCycles.pending, (state) => {
        state.planningCyclesLoadingStatus = Status.Loading;
      })
      .addCase(fetchPlanningCycles.fulfilled, (state, action) => {
        state.planningCycles = action.payload;
        state.planningCyclesLoadingStatus = Status.Completed;
      })
      .addCase(fetchPlanningCycles.rejected, (state) => {
        state.planningCyclesLoadingStatus = Status.Failed;
      })

      // Fetch Scenarios
      .addCase(fetchScenarios.fulfilled, (state, action) => {
        state.scenarios = action.payload;
      })
      .addCase(fetchScenarios.rejected, (state) => {
        // Handle rejection if needed
      })

      // Fetch Snapshots
      .addCase(fetchSnapshots.pending, (state) => {
        state.planningCycleSnapshotsStatus = Status.Loading;
      })
      .addCase(fetchSnapshots.fulfilled, (state, action) => {
        state.planningCycleSnapshots = action.payload;
        state.planningCycleSnapshotsStatus = Status.Completed;
      })
      .addCase(fetchSnapshots.rejected, (state) => {
        state.planningCycleSnapshots = [];
        state.planningCycleSnapshotsStatus = Status.Failed;
      })

      // Submit Planning Cycle
      .addCase(submitPlanningCycle.pending, (state) => {
        state.updateStatus = 'loading';
      })
      .addCase(submitPlanningCycle.fulfilled, (state) => {
        state.updateStatus = 'succeeded';
      })
      .addCase(submitPlanningCycle.rejected, (state, action: PayloadAction<any>) => {
        state.updateStatus = 'failed';
        state.updateError = action.payload;
      })

      // Fetch Forecast Planning Cycles
      .addCase(fetchForecastPlanningCycles.pending, (state) => {
        state.forecastPlanningCyclesStatus = Status.Loading;
      })
      .addCase(fetchForecastPlanningCycles.fulfilled, (state, action) => {
        state.forecastPlanningCycles = action.payload;
        state.forecastPlanningCyclesStatus = Status.Completed;
      })
      .addCase(fetchForecastPlanningCycles.rejected, (state) => {
        state.forecastPlanningCyclesStatus = Status.Failed;
      });
  }
});

export default planningCycleSlice.reducer;
